import React from 'react'
import { FormattedMessage } from 'react-intl'

import capitalizeString from 'utils/capitalize'
import { RedListCategoryStatus, TableNotQualifyIconWrapper } from './style'
import Tooltip from 'components/Tooltip'
import RejectIcon from 'assets/icons/reject-icon'
import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'

export const renderRedListCategoryStatus = (status) => {
  if (status === '-') {
    return (
      <div>
        -
      </div>
    )
  }
  const numberStatus = {
    1: 'CO',
    2: 'CR',
    3: 'EN',
    4: 'VU',
    5: 'NT',
    6: 'LC',
    7: 'DD',
    8: 'NE'
  }

  const color = {
    1: '#202020',
    2: 'rgba(216, 30, 5, 0.5)',
    3: 'rgba(252, 127, 63, 0.6)',
    4: 'rgba(249, 232, 20, 0.6)',
    5: 'rgba(204, 226, 38, 0.6)',
    6: 'rgba(96, 198, 89, 0.6)',
    7: '#D1D1C6',
    8: 'rgb(255, 255, 255)'
  }

  return (
    <RedListCategoryStatus color={color[status]}>
      <FormattedMessage id={numberStatus[status]} />
    </RedListCategoryStatus>
  )
}


const tooltipXOffset = 0
const tooltipYOffset = -16

const formattedRejectIconTooltipHint = (item) => {
  return item.map((element) => {
    return reassessmentTriggerReasons.find((elementId) => {
      return elementId.id === element
    }).name
  })
}

const notQulifyIcon = (hint) => {
  return (
    <Tooltip
      style={{ zIndex: 1000 }}
      placement='top'
      trigger={['hover']}
      align={{ offset: [tooltipXOffset, tooltipYOffset] }}
      overlay={{ label: 'nonQualifying', infoTooltip: formattedRejectIconTooltipHint(hint).join(', ') }}
    >
      <TableNotQualifyIconWrapper>
        <RejectIcon />
      </TableNotQualifyIconWrapper>
    </Tooltip>

  )
}

export const makeCalculationRowEco = (calculationDataEco, site) => {
  return calculationDataEco.map((item) => {
    const qualifies = site.reassessmentFlag ? item.triggerReasonId.some((element) => {
      // eslint-disable-next-line no-magic-numbers
      return element === 1
    }) : true
    return {
      ecosystemName: `${capitalizeString(item.ecosystemName)}`,
      iucnStatus: renderRedListCategoryStatus(item.iucnStatus),
      population: qualifies ? `${(Number(item.population.split('%').join('')) === Number.NEGATIVE_INFINITY) || (Number(item.population.split('%').join('')) === Number.POSITIVE_INFINITY) || (isNaN(Number(item.population.split('%').join('')))) ? '-' : `${item.population}`}` : '-',
      kbaCriteria: qualifies ? `${capitalizeString(item.kbaCriteria)}` : notQulifyIcon(item.triggerReasonId)
    }
  })
}

export const makeCalculationsColumnsEco = () => {
  return [
    {
      id: 'ecosystemName',
      header: (
        <>
          <FormattedMessage id='ecosystemName' />
        </>
      ),
      accessorKey: 'ecosystemName',
      style: {
        width: '65%'
      },
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'iucnStatus',
      header: (
        <>
          <FormattedMessage id='iucnStatus' />
        </>
      ),
      accessorKey: 'iucnStatus',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'population',
      header: (
        <>
          <FormattedMessage id='population' />
        </>
      ),
      accessorKey: 'population',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaCriteria',
      header: (
        <>
          <FormattedMessage id='kbaCriteria' />
        </>
      ),
      accessorKey: 'kbaCriteria',
      style: {
        width: '10%'
      },
      cell: ({ getValue }) => getValue()
    }
  ]
}
